<template>
  <form>
    <div
      class="modal-card"
      style="width: auto">
      <header class="modal-card-head">
        <p
          class="modal-card-title">
          <translate>Lägg till Nytt Lag</translate>
        </p>
      </header>
      <section class="modal-card-body">
        <b-field class="file">
          <b-upload v-model="file">
            <a class="button is-primary">
              <b-icon icon="upload" />
              <translate>Klicka för att ladda upp</translate>
            </a>
          </b-upload>
          <span
            v-if="file"
            class="file-name">
            {{ file.name }}
          </span>
        </b-field>
        <a
          class="button"
          href="/example.csv">
          <translate>Ladda ner exempel</translate>
        </a>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-primary"
          @click="save">
          <translate>Skicka</translate>
        </button>
      </footer>
    </div>
  </form>
</template>


<script>
import { teamService, countryService } from '../../_services';

export default {
  name: 'ImportTeam',
  props: {
    competition: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      loaded: false,
      file: null,
    }
  },
  async created() {
    var self = this
    self.countries = await countryService.getAll(self.id)
  },
  methods: {
    save: async function(){
      var self = this
      const data =
        {
          file: self.file,
          competition: self.competition,
        }
      await teamService.postBulk(data)
    }
  },
}
</script>
